angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "BOOKING_ACTION": {
    "BOOK_SENDER": "You have requested to book {NAME}",
    "BOOK": "Booking request from {NAME}",
    "MODIFY_SENDER": "You have requested to book {NAME}",
    "MODIFY": "Booking request from {NAME}",
    "ACCEPT_SENDER": "You have requested to book {NAME}",
    "ACCEPT": "Booking request from {NAME}",
    "DECLINE_SENDER": "You have declined a booking from {NAME}",
    "DECLINE": "We’re really sorry, but {NAME} is not available for this booking",
    "OFFER_DECLINE_SENDER": "You skipped this offer.",
    "OFFER_DECLINE": "Offer was not accepted",
    "CANCEL_SENDER": "You have cancelled this booking request",
    "CANCEL": "{NAME} has cancelled this booking request",
    "PAY_SENDER": "Upfront payment complete",
    "PAY": "Upfront payment complete",
    "EXPIRE": "Booking request expired",
    "EXPIRE_SENDER": "Booking request expired",
    "REVIEW": "You can now leave a review about your booking",
    "REVIEW_SENDER": "You can now leave a review about your booking",
    "AUTODECLINE": "Sorry, I'm not available for this booking",
    "AUTODECLINE_SENDER": "Booking request was cancelled",

  },
  "BOOKING_STATUS": {
    "PENDING": "Booking Request",
    "PENDING_SENDER": "Booking Request",
    "ACCEPT": "Booking Request",
    "ACCEPT_SENDER": "Booking Request",
    "PAY": "Booking Paid",
    "PAY_SENDER": "Booking Paid",
    "CANCEL": "Cancelled",
    "CANCEL_SENDER": "Cancelled",
    "DECLINE": "Not Available",
    "DECLINE_SENDER": "Not Available",
    "REVIEW": "Leave a Review",
    "REVIEW_SENDER": "Leave a Review",
    "EXPIRE": "Expired",
    "EXPIRE_SENDER": "Expired",
    "AUTODECLINE": "Not Available",
    "AUTODECLINE_SENDER": "Cancelled",
    "CONFIRM": "Confirm",
    "CONFIRM_SENDER": "Confirm",
    "OFFER": "Offer",
    "OFFER_SENDER": "Offer",
    "OFFER_ACCEPT": "Offer",
    "OFFER_ACCEPT_SENDER": "Offer",
    "OFFER_DECLINE": "Cancelled",
    "OFFER_DECLINE_SENDER": "Cancelled",
  },
  "BOOKING_STATUS_LONG": {
    "ACCEPT_SENDER": "Awaiting payment from {NAME}",
    "ACCEPT": "Awaiting your payment"
  },
  "BOOKING_DURATION": "for {HOURS, plural, one{# hour} other{# hours}}"
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/nls/booking.json
// module id = 82
// module chunks = 24